import type { Context } from '@white-label-types/middleware';
import type { AuthObject } from '@white-label-types/auth';

import { handleSSOToken, isDedicatedFlow } from '@white-label-helper/dedicated-flow';
import { datadogRum } from '@datadog/browser-rum';
interface ContextWithInstalledModules extends Context {
  $auth: AuthObject;
}

const dedicatedSSO = async ({
  redirect,
  $auth,
  route,
  app,
}: ContextWithInstalledModules): Promise<unknown> => {
  if (!process.client) {
    return;
  }
  if(isDedicatedFlow(route)) {
    // get the cookies from the app instance
    const ssoToken = app['$cookies'].get('sso_token');

    try {
      await handleSSOToken($auth, ssoToken);

      if (!$auth.isAuthenticated) {
        // if not authenticated, redirect to ecom home
        redirect('/');
      }
    } catch (error) {
      const context = {
        file: 'wl-ecom > middleware > dedicated-sso.ts',
        authObj: $auth || '',
        isAuthenticated: $auth?.isAuthenticated || '',
      }

      console.error('Dedicated Flow - Error authorising user', context);
      datadogRum.addError(
        new Error('Dedicated Flow - Error authorising user:', { cause: error }),
        context
      );

      try {
        await $auth.logout();
      } catch (error) {
        console.error(error)
        datadogRum.addError(
          new Error('Dedicated Flow - auth unable to logout:', { cause: error }));
      }
    }
  }
};

export default dedicatedSSO;
